import ErrorPage from 'components/UI/ErrorPage'
import { useI18n } from 'context/I18nProvider'

export default function Page403() {
  const { i18n } = useI18n()

  return <ErrorPage customError={{ statusText: i18n('page-403.text') }} title="403" />
}
